module.exports = __webpack_public_path__ + "static/media/myvideo.2fb7fe1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/myvideo.mp4
// module id = LPmg
// module chunks = 1